/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CarrierType } from '../model';
// @ts-ignore
import type { CarrierVisitDirection } from '../model';
// @ts-ignore
import type { ContainerHeight } from '../model';
// @ts-ignore
import type { ContainerStackOutSequenceItemDto } from '../model';
// @ts-ignore
import type { ContainerStatus } from '../model';
// @ts-ignore
import type { ContainerTurnoverBasicInfoDto } from '../model';
// @ts-ignore
import type { ContainerTurnoverDto } from '../model';
// @ts-ignore
import type { ContainerTurnoverDtoPaginatedList } from '../model';
// @ts-ignore
import type { ContainerTurnoverYardPositionDto } from '../model';
// @ts-ignore
import type { ContainerType } from '../model';
// @ts-ignore
import type { ContainerYardOperationDto } from '../model';
// @ts-ignore
import type { DeviceOperationMode } from '../model';
// @ts-ignore
import type { GuidOptionDtoPaginatedList } from '../model';
// @ts-ignore
import type { PaginationQuery } from '../model';
// @ts-ignore
import type { SuggestedContainerDto } from '../model';
// @ts-ignore
import type { UnitType } from '../model';
/**
 * ContainerTurnoversApi - axios parameter creator
 */
export const ContainerTurnoversApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAll: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {PaginationQuery} [paginationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAllAsOptions: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, paginationQuery?: PaginationQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetAllAsOptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginationQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAllBasicInfo: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetAllBasicInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetByOrderId: async (orderId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetByOrderId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerPositionByNumber: async (containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetContainerPositionByNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerOrReferenceNumber !== undefined) {
                localVarQueryParameter['ContainerOrReferenceNumber'] = containerOrReferenceNumber;
            }

            if (inboundCarrierType !== undefined) {
                localVarQueryParameter['InboundCarrierType'] = inboundCarrierType;
            }

            if (outboundCarrierType !== undefined) {
                localVarQueryParameter['OutboundCarrierType'] = outboundCarrierType;
            }

            if (inboundCarrier !== undefined) {
                localVarQueryParameter['InboundCarrier'] = inboundCarrier;
            }

            if (outboundCarrier !== undefined) {
                localVarQueryParameter['OutboundCarrier'] = outboundCarrier;
            }

            if (isEmpty !== undefined) {
                localVarQueryParameter['IsEmpty'] = isEmpty;
            }

            if (size !== undefined) {
                localVarQueryParameter['Size'] = size;
            }

            if (containerIsoCode !== undefined) {
                localVarQueryParameter['ContainerIsoCode'] = containerIsoCode;
            }

            if (typeCode !== undefined) {
                localVarQueryParameter['TypeCode'] = typeCode;
            }

            if (portOfLoading !== undefined) {
                localVarQueryParameter['PortOfLoading'] = portOfLoading;
            }

            if (portOfDischarge !== undefined) {
                localVarQueryParameter['PortOfDischarge'] = portOfDischarge;
            }

            if (weightClasses) {
                localVarQueryParameter['WeightClasses'] = weightClasses;
            }

            if (isReefer !== undefined) {
                localVarQueryParameter['IsReefer'] = isReefer;
            }

            if (isDamaged !== undefined) {
                localVarQueryParameter['IsDamaged'] = isDamaged;
            }

            if (imoClasses) {
                localVarQueryParameter['ImoClasses'] = imoClasses;
            }

            if (isRestow !== undefined) {
                localVarQueryParameter['IsRestow'] = isRestow;
            }

            if (containerOperator !== undefined) {
                localVarQueryParameter['ContainerOperator'] = containerOperator;
            }

            if (consignee !== undefined) {
                localVarQueryParameter['Consignee'] = consignee;
            }

            if (isDangerous !== undefined) {
                localVarQueryParameter['IsDangerous'] = isDangerous;
            }

            if (locationStatus !== undefined) {
                localVarQueryParameter['LocationStatus'] = locationStatus;
            }

            if (containerType !== undefined) {
                localVarQueryParameter['ContainerType'] = containerType;
            }

            if (containerHeight !== undefined) {
                localVarQueryParameter['ContainerHeight'] = containerHeight;
            }

            if (isInTerminal !== undefined) {
                localVarQueryParameter['isInTerminal'] = isInTerminal;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (containerUnitType) {
                localVarQueryParameter['ContainerUnitType'] = containerUnitType;
            }

            if (isOOG !== undefined) {
                localVarQueryParameter['IsOOG'] = isOOG;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerTurnoverByContainerNumber: async (containerNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetContainerTurnoverByContainerNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumber !== undefined) {
                localVarQueryParameter['containerNumber'] = containerNumber;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [carrierVisitId] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerTurnoversByCarrierVisit: async (carrierVisitId?: number, direction?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetContainerTurnoversByCarrierVisit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (carrierVisitId !== undefined) {
                localVarQueryParameter['CarrierVisitId'] = carrierVisitId;
            }

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetDetails: async (id?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<number>} [containerIds] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetEasiestToReach: async (containerIds?: Array<number>, amount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetEasiestToReach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerIds) {
                localVarQueryParameter['ContainerIds'] = containerIds;
            }

            if (amount !== undefined) {
                localVarQueryParameter['Amount'] = amount;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {DeviceOperationMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetStackOutSequence: async (referenceNumber?: string, mode?: DeviceOperationMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetStackOutSequence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (referenceNumber !== undefined) {
                localVarQueryParameter['referenceNumber'] = referenceNumber;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetTurnoversByCarrierDirection: async (direction?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetTurnoversByCarrierDirection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['Direction'] = direction;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {number} [orderId] 
         * @param {boolean} [isStackIn] 
         * @param {DeviceOperationMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetYardOperationData: async (containerNumber?: string, orderId?: number, isStackIn?: boolean, mode?: DeviceOperationMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/ContainerTurnovers/GetYardOperationData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (containerNumber !== undefined) {
                localVarQueryParameter['containerNumber'] = containerNumber;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (isStackIn !== undefined) {
                localVarQueryParameter['isStackIn'] = isStackIn;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerTurnoversApi - functional programming interface
 */
export const ContainerTurnoversApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerTurnoversApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetAll(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerTurnoverDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetAll(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {PaginationQuery} [paginationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetAllAsOptions(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, paginationQuery?: PaginationQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuidOptionDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetAllAsOptions(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, paginationQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetAllAsOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetAllBasicInfo(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverBasicInfoDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetAllBasicInfo(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetAllBasicInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetByOrderId(orderId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerTurnoverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetByOrderId(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetByOrderId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerOrReferenceNumber] 
         * @param {CarrierType} [inboundCarrierType] 
         * @param {CarrierType} [outboundCarrierType] 
         * @param {number} [inboundCarrier] 
         * @param {number} [outboundCarrier] 
         * @param {boolean} [isEmpty] 
         * @param {number} [size] 
         * @param {string} [containerIsoCode] 
         * @param {string} [typeCode] 
         * @param {string} [portOfLoading] 
         * @param {string} [portOfDischarge] 
         * @param {Array<string>} [weightClasses] 
         * @param {boolean} [isReefer] 
         * @param {boolean} [isDamaged] 
         * @param {Array<string>} [imoClasses] 
         * @param {boolean} [isRestow] 
         * @param {string} [containerOperator] 
         * @param {string} [consignee] 
         * @param {boolean} [isDangerous] 
         * @param {ContainerStatus} [locationStatus] 
         * @param {ContainerType} [containerType] 
         * @param {ContainerHeight} [containerHeight] 
         * @param {boolean} [isInTerminal] 
         * @param {number} [customerId] 
         * @param {Array<UnitType>} [containerUnitType] 
         * @param {boolean} [isOOG] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetContainerPositionByNumber(containerOrReferenceNumber?: string, inboundCarrierType?: CarrierType, outboundCarrierType?: CarrierType, inboundCarrier?: number, outboundCarrier?: number, isEmpty?: boolean, size?: number, containerIsoCode?: string, typeCode?: string, portOfLoading?: string, portOfDischarge?: string, weightClasses?: Array<string>, isReefer?: boolean, isDamaged?: boolean, imoClasses?: Array<string>, isRestow?: boolean, containerOperator?: string, consignee?: string, isDangerous?: boolean, locationStatus?: ContainerStatus, containerType?: ContainerType, containerHeight?: ContainerHeight, isInTerminal?: boolean, customerId?: number, containerUnitType?: Array<UnitType>, isOOG?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverYardPositionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetContainerPositionByNumber(containerOrReferenceNumber, inboundCarrierType, outboundCarrierType, inboundCarrier, outboundCarrier, isEmpty, size, containerIsoCode, typeCode, portOfLoading, portOfDischarge, weightClasses, isReefer, isDamaged, imoClasses, isRestow, containerOperator, consignee, isDangerous, locationStatus, containerType, containerHeight, isInTerminal, customerId, containerUnitType, isOOG, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetContainerPositionByNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetContainerTurnoverByContainerNumber(containerNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerTurnoverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetContainerTurnoverByContainerNumber(containerNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetContainerTurnoverByContainerNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [carrierVisitId] 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetContainerTurnoversByCarrierVisit(carrierVisitId?: number, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetContainerTurnoversByCarrierVisit(carrierVisitId, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetContainerTurnoversByCarrierVisit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetDetails(id?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerTurnoverDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<number>} [containerIds] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetEasiestToReach(containerIds?: Array<number>, amount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SuggestedContainerDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetEasiestToReach(containerIds, amount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetEasiestToReach']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [referenceNumber] 
         * @param {DeviceOperationMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetStackOutSequence(referenceNumber?: string, mode?: DeviceOperationMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerStackOutSequenceItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetStackOutSequence(referenceNumber, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetStackOutSequence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetTurnoversByCarrierDirection(direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContainerTurnoverDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetTurnoversByCarrierDirection(direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetTurnoversByCarrierDirection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [containerNumber] 
         * @param {number} [orderId] 
         * @param {boolean} [isStackIn] 
         * @param {DeviceOperationMode} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async containerTurnoversGetYardOperationData(containerNumber?: string, orderId?: number, isStackIn?: boolean, mode?: DeviceOperationMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerYardOperationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.containerTurnoversGetYardOperationData(containerNumber, orderId, isStackIn, mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerTurnoversApi.containerTurnoversGetYardOperationData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerTurnoversApi - factory interface
 */
export const ContainerTurnoversApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerTurnoversApiFp(configuration)
    return {
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAll(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContainerTurnoverDtoPaginatedList> {
            return localVarFp.containerTurnoversGetAll(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetAllAsOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAllAsOptions(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllAsOptionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GuidOptionDtoPaginatedList> {
            return localVarFp.containerTurnoversGetAllAsOptions(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, requestParameters.paginationQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetAllBasicInfo(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverBasicInfoDto>> {
            return localVarFp.containerTurnoversGetAllBasicInfo(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetByOrderId(requestParameters: ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContainerTurnoverDto> {
            return localVarFp.containerTurnoversGetByOrderId(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerPositionByNumber(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverYardPositionDto>> {
            return localVarFp.containerTurnoversGetContainerPositionByNumber(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetContainerTurnoverByContainerNumberRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerTurnoverByContainerNumber(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerTurnoverByContainerNumberRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContainerTurnoverDto> {
            return localVarFp.containerTurnoversGetContainerTurnoverByContainerNumber(requestParameters.containerNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetContainerTurnoversByCarrierVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetContainerTurnoversByCarrierVisit(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerTurnoversByCarrierVisitRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverDto>> {
            return localVarFp.containerTurnoversGetContainerTurnoversByCarrierVisit(requestParameters.carrierVisitId, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetDetails(requestParameters: ContainerTurnoversApiContainerTurnoversGetDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContainerTurnoverDto> {
            return localVarFp.containerTurnoversGetDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetEasiestToReachRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetEasiestToReach(requestParameters: ContainerTurnoversApiContainerTurnoversGetEasiestToReachRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<SuggestedContainerDto>> {
            return localVarFp.containerTurnoversGetEasiestToReach(requestParameters.containerIds, requestParameters.amount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetStackOutSequenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetStackOutSequence(requestParameters: ContainerTurnoversApiContainerTurnoversGetStackOutSequenceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerStackOutSequenceItemDto>> {
            return localVarFp.containerTurnoversGetStackOutSequence(requestParameters.referenceNumber, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetTurnoversByCarrierDirectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetTurnoversByCarrierDirection(requestParameters: ContainerTurnoversApiContainerTurnoversGetTurnoversByCarrierDirectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContainerTurnoverDto>> {
            return localVarFp.containerTurnoversGetTurnoversByCarrierDirection(requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ContainerTurnoversApiContainerTurnoversGetYardOperationDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        containerTurnoversGetYardOperationData(requestParameters: ContainerTurnoversApiContainerTurnoversGetYardOperationDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ContainerYardOperationDto> {
            return localVarFp.containerTurnoversGetYardOperationData(requestParameters.containerNumber, requestParameters.orderId, requestParameters.isStackIn, requestParameters.mode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for containerTurnoversGetAll operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetAllRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean

    readonly pageNumber?: number

    readonly pageSize?: number
}

/**
 * Request parameters for containerTurnoversGetAllAsOptions operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetAllAsOptionsRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean

    readonly paginationQuery?: PaginationQuery
}

/**
 * Request parameters for containerTurnoversGetAllBasicInfo operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean
}

/**
 * Request parameters for containerTurnoversGetByOrderId operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest {
    readonly orderId?: number
}

/**
 * Request parameters for containerTurnoversGetContainerPositionByNumber operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest {
    readonly containerOrReferenceNumber?: string

    readonly inboundCarrierType?: CarrierType

    readonly outboundCarrierType?: CarrierType

    readonly inboundCarrier?: number

    readonly outboundCarrier?: number

    readonly isEmpty?: boolean

    readonly size?: number

    readonly containerIsoCode?: string

    readonly typeCode?: string

    readonly portOfLoading?: string

    readonly portOfDischarge?: string

    readonly weightClasses?: Array<string>

    readonly isReefer?: boolean

    readonly isDamaged?: boolean

    readonly imoClasses?: Array<string>

    readonly isRestow?: boolean

    readonly containerOperator?: string

    readonly consignee?: string

    readonly isDangerous?: boolean

    readonly locationStatus?: ContainerStatus

    readonly containerType?: ContainerType

    readonly containerHeight?: ContainerHeight

    readonly isInTerminal?: boolean

    readonly customerId?: number

    readonly containerUnitType?: Array<UnitType>

    readonly isOOG?: boolean
}

/**
 * Request parameters for containerTurnoversGetContainerTurnoverByContainerNumber operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetContainerTurnoverByContainerNumberRequest {
    readonly containerNumber?: string
}

/**
 * Request parameters for containerTurnoversGetContainerTurnoversByCarrierVisit operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetContainerTurnoversByCarrierVisitRequest {
    readonly carrierVisitId?: number

    readonly direction?: CarrierVisitDirection
}

/**
 * Request parameters for containerTurnoversGetDetails operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetDetailsRequest {
    readonly id?: string
}

/**
 * Request parameters for containerTurnoversGetEasiestToReach operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetEasiestToReachRequest {
    readonly containerIds?: Array<number>

    readonly amount?: number
}

/**
 * Request parameters for containerTurnoversGetStackOutSequence operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetStackOutSequenceRequest {
    readonly referenceNumber?: string

    readonly mode?: DeviceOperationMode
}

/**
 * Request parameters for containerTurnoversGetTurnoversByCarrierDirection operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetTurnoversByCarrierDirectionRequest {
    readonly direction?: CarrierVisitDirection
}

/**
 * Request parameters for containerTurnoversGetYardOperationData operation in ContainerTurnoversApi.
 */
export interface ContainerTurnoversApiContainerTurnoversGetYardOperationDataRequest {
    readonly containerNumber?: string

    readonly orderId?: number

    readonly isStackIn?: boolean

    readonly mode?: DeviceOperationMode
}

/**
 * ContainerTurnoversApi - object-oriented interface
 */
export class ContainerTurnoversApi extends BaseAPI {
    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetAll(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetAll(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, requestParameters.pageNumber, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetAllAsOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetAllAsOptions(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllAsOptionsRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetAllAsOptions(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, requestParameters.paginationQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetAllBasicInfo(requestParameters: ContainerTurnoversApiContainerTurnoversGetAllBasicInfoRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetAllBasicInfo(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetByOrderId(requestParameters: ContainerTurnoversApiContainerTurnoversGetByOrderIdRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetByOrderId(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetContainerPositionByNumber(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerPositionByNumberRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetContainerPositionByNumber(requestParameters.containerOrReferenceNumber, requestParameters.inboundCarrierType, requestParameters.outboundCarrierType, requestParameters.inboundCarrier, requestParameters.outboundCarrier, requestParameters.isEmpty, requestParameters.size, requestParameters.containerIsoCode, requestParameters.typeCode, requestParameters.portOfLoading, requestParameters.portOfDischarge, requestParameters.weightClasses, requestParameters.isReefer, requestParameters.isDamaged, requestParameters.imoClasses, requestParameters.isRestow, requestParameters.containerOperator, requestParameters.consignee, requestParameters.isDangerous, requestParameters.locationStatus, requestParameters.containerType, requestParameters.containerHeight, requestParameters.isInTerminal, requestParameters.customerId, requestParameters.containerUnitType, requestParameters.isOOG, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetContainerTurnoverByContainerNumberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetContainerTurnoverByContainerNumber(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerTurnoverByContainerNumberRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetContainerTurnoverByContainerNumber(requestParameters.containerNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetContainerTurnoversByCarrierVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetContainerTurnoversByCarrierVisit(requestParameters: ContainerTurnoversApiContainerTurnoversGetContainerTurnoversByCarrierVisitRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetContainerTurnoversByCarrierVisit(requestParameters.carrierVisitId, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetDetails(requestParameters: ContainerTurnoversApiContainerTurnoversGetDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetEasiestToReachRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetEasiestToReach(requestParameters: ContainerTurnoversApiContainerTurnoversGetEasiestToReachRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetEasiestToReach(requestParameters.containerIds, requestParameters.amount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetStackOutSequenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetStackOutSequence(requestParameters: ContainerTurnoversApiContainerTurnoversGetStackOutSequenceRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetStackOutSequence(requestParameters.referenceNumber, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetTurnoversByCarrierDirectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetTurnoversByCarrierDirection(requestParameters: ContainerTurnoversApiContainerTurnoversGetTurnoversByCarrierDirectionRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetTurnoversByCarrierDirection(requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ContainerTurnoversApiContainerTurnoversGetYardOperationDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public containerTurnoversGetYardOperationData(requestParameters: ContainerTurnoversApiContainerTurnoversGetYardOperationDataRequest = {}, options?: RawAxiosRequestConfig) {
        return ContainerTurnoversApiFp(this.configuration).containerTurnoversGetYardOperationData(requestParameters.containerNumber, requestParameters.orderId, requestParameters.isStackIn, requestParameters.mode, options).then((request) => request(this.axios, this.basePath));
    }
}

